import React, { useState, useEffect, useRef } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../Provider/AuthProvider'
import ModalCheckInCenter from '../../components/CheckIn/CheckInCenter'
import io from 'socket.io-client'
import { entries } from '../../types/entries'
import { listBrandsAll } from '../../services/brand'
import { startCamerasLocaFile, listcamerasFile } from '../../services/cameras'
import { brand } from '../../types/brand'
import { AccessConfig } from '../../types/AccessConfig'
import './style.scss'
import SocketReadQr from '../../components/CheckIn/SocketNotifications/readQr'

const MAX_CAMERA_RETRIES = 2
const RETRY_DELAY_MS = 1000

const CheckFiles = () => {
  const { user, token } = useAuth()
  const [brands, setBrands] = useState<brand[]>([])
  const [clientCameras, setclientCameras] = useState<AccessConfig[]>([])
  const [newEntrySocket, setNewEntrySocket] = useState<entries | undefined>()
  const fetchStartedRef = useRef(false)

  useEffect(() => {
    if (!user?.clientId) return
    if (fetchStartedRef.current) return
    fetchStartedRef.current = true

    let cancelled = false

    const fetchCamerasWithRetry = async (clientId: string): Promise<AccessConfig[]> => {
      for (let attempt = 0; attempt <= MAX_CAMERA_RETRIES; attempt++) {
        const cameras = await listcamerasFile(clientId)
        if (cancelled) return []
        if (cameras.length > 0 || attempt === MAX_CAMERA_RETRIES) {
          return cameras
        }
        await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS))
        if (cancelled) return []
      }
      return []
    }

    const getData = async () => {
      try {
        const brandsRes = await listBrandsAll(token)
        if (cancelled) return
        setBrands(brandsRes)
        const cameras = await fetchCamerasWithRetry(user.clientId as string)
        if (cancelled) return
        setclientCameras(cameras)
      } catch (error) {
        console.error(error)
        fetchStartedRef.current = false
      }
    }

    getData()

    return () => {
      cancelled = true
    }
  }, [user?.clientId, token])

  useEffect(() => {
    if (clientCameras.length === 0) return

    const socketFiles = io('http://localhost:8085')
    socketFiles.on('connect', () => {
      console.log('Conectado al servidor local')
      startCamerasLocaFile(clientCameras, token)
    })

    return () => {
      socketFiles.disconnect()
    }
  }, [clientCameras, token])

  if (!user) {
    return <Navigate to="/login" />
  }
  return (
    <div className="homeContainer">
      <div className="containerTitle">
        <h4>Check-in Central {user.client?.name || ''}</h4>
      </div>
      {brands.length > 0 &&
        clientCameras.length > 0 &&
        clientCameras.map((camera, index) => (
          <div key={index} className={`divCamera ${camera.name}`}>
            <ModalCheckInCenter
              newEntrySocket={newEntrySocket}
              brands={brands}
              camera={camera}
            />
          </div>
        ))}
      {
        
      }
      {<SocketReadQr userId={user?.clientId} setNewEntrySocket={setNewEntrySocket} />}
    </div>
  )
}

export default CheckFiles
